import { AccessRules } from '../../enums/Authority';

/**
 * A class that describes a single user group.
 */
export class UserGroup {
  email: string;
  description: string;
  accessRules: AccessRules[];

  /**
   * @param email the email of the group.
   * @param description the description of the group.
   * @param accessRules actions a user group is allowed to perform.
   */
  constructor(email: string, description: string, accessRules: AccessRules[]) {
    this.email = email;
    this.description = description;
    this.accessRules = accessRules;
  }
}
